import "./IvStoreViewComponent.scss";
import {IComponentOptions, IScope} from "angular";
import {IvStoreViewStore} from "../services/IvStoreViewStore";
import {IvStoreService} from "../services/IvStoreService";
import {CurrentUserService} from "../../../services/user/CurrentUserService";
import {StateService} from "@uirouter/core";
import {StoreStateParams} from "../../common/models/StoreStateParams";
import {StoreController} from "../../common/controllers/StoreController";
import {IvProductMappings, IvStoreProduct} from "../models/IvStoreProduct";

export const IvStoreView = "ivStoreView";

export function ivStoreView(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/view/IvStoreViewComponent.html`,
        bindings: {
            viewStore: "<"
        },
        controllerAs: "ctrl",
        controller: IvStoreViewComponentController
    };
}

export class IvStoreViewComponentController extends StoreController<IvStoreProduct> {

    public viewStore: IvStoreViewStore;

    /** @ngInject */
    public constructor($scope: IScope,
                       ivStoreService: IvStoreService,
                       currentUserService: CurrentUserService,
                       $stateParams: StoreStateParams<IvStoreProduct>,
                       $state: StateService,
                       simpleModalService: any) {
        super($scope, ivStoreService, currentUserService, $stateParams, $state, IvProductMappings, simpleModalService);
    }
}
